import Modal from "./Modal";
import React, { useEffect, useRef } from "react";
import { ModalSize } from "../enums/ModalSize";
import { useQuery } from "@apollo/client";
import { FIND_ALL_FRAUDS_QUERY } from "../../Queries";
import { Fraud } from "../../generated/graphql";
import FraudNotice from "./FraudNotice";
import { useFormikContext } from "formik";
import { FormValues } from "../common/FormValues";
import CenteredFullWidthDiv from "./CenteredFullWidthDiv";
import Checkbox from "../input/Checkbox";
import Button from "../button/Button";
import { PdsModal } from "@principal/design-system-react";

export type FraudModalProps = {
    onClose?: (e: Event) => void,
    inModal?: boolean
}

const FraudModal = (props: FraudModalProps) => {
    const {data: fraudsData} = useQuery(FIND_ALL_FRAUDS_QUERY)
    const frauds = fraudsData?.findAllFrauds as Fraud[]
    const { values } = useFormikContext<FormValues>();
    const consent = values.fraudConsent;
    const modalRef = useRef<typeof PdsModal & { openModal: Function, closeModal: Function }>(null);

    useEffect(() => {
        if(props.inModal && modalRef.current) {
            modalRef.current.openModal();
        }
    }, [props.inModal])

    if (consent === undefined) {
        return null;
    }

    const handleContinue = () => {
        modalRef.current?.closeModal(new CustomEvent('close'));
    }

    return <Modal id="fraud-validation"
                  headerText="Fraud notice requirements"
                  ref={modalRef}
                  modalContent={<div id="fraud-validation-content" className="flex-gap">
                      {frauds?.filter(fraud => !fraud.aboveSignature)?.map((fraud, index) =>
                          <FraudNotice key={index} fraud={fraud}/>
                      )}
                      <CenteredFullWidthDiv divContent={
                        <Checkbox id="fraud-consent" label="I agree"/>
                      }/>
                  </div>}
                  modalFooter={<>
                      {consent && <Button buttonContent="Continue" onClick={handleContinue}/>}
                  </>}
                  onClose={props.onClose}
                  modalSize={ModalSize.LARGE}
                  openOnLoad={false}
                  closeable={true}/>;
}

export default FraudModal;
